import React, { Component, Fragment } from 'react'
import { Accordion, Card, Collapse } from 'react-bootstrap'
import parse, { domToReact } from 'html-react-parser'
import Feedback from './Feedback'
import { BRAND } from '../constants/appConstants'

const options = {
  replace: domNode => {
    const { attribs, name, children } = domNode

    if (name === 'font') {
      return <Fragment>{domToReact(children, options)}</Fragment>
    }

    if (attribs && attribs.id === 'remove') {
      return <Fragment />
    }
  }
}

class FaqItem extends Component {
  constructor() {
    super()

    this.state = {
      feedback: false
    }
  }

  render() {
    const { item, brand } = this.props
    const { feedback, open } = this.state

    const iconClass = brand === BRAND.TOYOTA ? 'dxp-icon icon-Chevron_Down-small' : 'icon icon-chevron-down'

    return (
      <Card key={item.nodeId} className={open ? 'open' : ''}>
        <Accordion.Toggle as={Card.Header} eventKey={item.nodeId}>
          {item.displayText}
          <i className={iconClass}></i>
        </Accordion.Toggle>
        <Accordion.Collapse
          eventKey={item.nodeId}
          onEnter={() => {
            this.setState({ open: true })
          }}
          onExit={() => {
            this.setState({ feedback: false, open: false })
          }}
        >
          <Card.Body>
            {parse(item.solutionText, options)}
            <div className="feedback">
              <div className="helpful">
                <h5>Heeft deze informatie u geholpen?</h5>
                <ul className="list-inline">
                  <li>
                    <button
                      className="btn btn-primary"
                      onClick={() => this.setState({ feedback: 'Goed' })}
                    >
                      Ja
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn btn-secondary"
                      onClick={() => this.setState({ feedback: 'Matig' })}
                    >
                      Nee
                    </button>
                  </li>
                </ul>
              </div>
              <div className="form">
                <Collapse in={!!feedback}>
                  <div>
                    <Feedback item={item} />
                  </div>
                </Collapse>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    )
  }
}

export default FaqItem
